import React, { useContext, useEffect, useState, useCallback } from 'react';
import { Col, Form, Modal, Row } from 'react-bootstrap';
import { sortBy } from 'lodash';

import { ApiServiceServerless } from '../../xhr_libs';
import AppContext from '../../contexts/app-context';
import AddEntityActionButtons from '../forms/AddEntityActionButtons';

function ProviderShareOrganizationModal(props) {
  const { show, onHide, organizationId, provider_type, poso, setposo } = props;
  const { userOrganizations, showToast } = useContext(AppContext);

  const [recipientOrg, setRecipientOrg] = useState('');
  const [availableOrgs, setAvailableOrgs] = useState([]);
  const [sharedOrgs, setSharedOrgs] = useState([]);

  useEffect(() => {
    let shares = [];
    if (poso) {
      shares = poso
        .filter((share) => share.provider_type === provider_type)
        .map((share) => {
          return share.recipient_id;
        });
    }
    setSharedOrgs(shares);
  }, [organizationId, poso, provider_type]);

  const handleSubmit = () => {
    const params = {
      owner_id: organizationId,
      recipient_id: recipientOrg,
      provider_type: provider_type,
    };
    ApiServiceServerless.post(`/providers/organization-share`, params, {
      authorization_id: organizationId,
    })
      .then(() => {
        showToast('success', 'Success', 'Credentials Shared');
        setRecipientOrg('');
        setposo((prev) => [
          ...prev,
          {
            owner_id: parseInt(organizationId),
            recipient_id: parseInt(recipientOrg),
            provider_type: parseInt(provider_type),
          },
        ]);
        onHide();
      })
      .catch((error) => {
        showToast('danger', 'Error', error);
        onHide();
      });
  };

  const findAvailableOrgs = useCallback(
    (orgId) => {
      const orgs = [];
      userOrganizations.forEach((org) => {
        if (org.id !== orgId && !sharedOrgs.includes(org.id)) {
          orgs.push(org);
        }
        setAvailableOrgs(orgs);
      });
    },
    [userOrganizations, sharedOrgs]
  );

  useEffect(() => {
    findAvailableOrgs(organizationId);
  }, [organizationId, findAvailableOrgs]);

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>Share Provider Credentials</Modal.Header>
      {availableOrgs.length === 0 ? (
        <Row
          style={{
            textAlign: 'center',
            minHeight: '75px',
            paddingTop: '15px',
          }}
        >
          <Col sm={12}>No Organizations to Share With</Col>
        </Row>
      ) : (
        <Form
          style={{ textAlign: 'left' }}
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <Modal.Body>
            <Form.Group controlId='formToOrg'>
              <Form.Label>Organization to Share with</Form.Label>
              <Form.Control
                style={{ float: 'right', width: '240px' }}
                as='select'
                size='sm'
                onChange={(e) => {
                  setRecipientOrg(e.target.value);
                }}
                defaultValue={'null-option'}
              >
                <option
                  key={'null-option'}
                  value={'null-option'}
                  disabled
                  hidden
                ></option>
                {sortBy(availableOrgs, ['name']).map((org) => (
                  <option key={`org-opt-${org.id}`} value={org.id}>
                    {org.name}
                  </option>
                ))}{' '}
                )
              </Form.Control>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <AddEntityActionButtons
              onCancel={onHide}
              submitDisabled={recipientOrg === ''}
            />
          </Modal.Footer>
        </Form>
      )}
    </Modal>
  );
}

export default ProviderShareOrganizationModal;
